/* eslint-disable radix */
import DatePicker, { registerLocale } from 'react-datepicker';
import React, { Component } from 'react';
import { FaRegCalendarAlt } from "react-icons/fa";
import id from 'date-fns/locale/id'
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
registerLocale("id", id);

class DateInputField extends Component {

    DateCustomInput = ({ value, onClick }) => (
        <div className="datepicker-group">
            <input type="text" className={`datepicker-form-control ${this.props.disabled?'disabled':''} `} onClick={onClick} onChange={onClick} value={value} disabled={this.props.disabled} />
            <div className="datepicker-group-icon">
                <i className="material-icons">date_range</i>
            </div>
        </div>
    );

    TimeCustomInput = ({ value, onClick }) => (
        <div className="datepicker-group">
            <input type="text" className={`datepicker-form-control datepicker-input-time ${this.props.disabled?'disabled':''} `} onClick={onClick} onChange={onClick} value={value} disabled={this.props.disabled} />
            <div className="datepicker-group-icon">
                <i className="material-icons">access_time</i>
            </div>
        </div>
    );

    render() {
        const {
            value,
            field,
            dateFormat,
            type,minDate,placeholder,maxDate
        } = this.props;

        var xValue = value;

        if(type != null || type === 'Time'){            
            if(this.props.convertvalue && value !== ''){
                const x = value.split(':');
                xValue = new Date() 
                xValue.setHours(x[0]);
                xValue.setMinutes(x[1]);
            }
                       
            return (
                <DatePicker 
                    
                    className={`${this.props.className}`}
                    locale="id"
                    selected={xValue==="" ? null : xValue}
                    minDate={new Date()}
                    maxDate={ new Date()}
                    onChange={(date) => {
                        if(this.props.convertvalue){
                            var hh = new Intl.DateTimeFormat('en', { hour: '2-digit', hour12: false }).format(date)
                            var mm = new Intl.DateTimeFormat('en', { minute: '2-digit' }).format(date)
                            
                            if(hh=='24'){
                                hh='00';
                            }
                            if(mm=='0'){
                                mm='00'
                            }
                            const v = `${hh}:${mm}`
                            this.props.onChange(field, v);
                            console.log(v)
                        }else{
                            this.props.onChange(field, date);
                            console.log(date)
                        }
                        
                    }}
                    dateFormat={ "HH:mm" }
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    placeholderText={placeholder}
                    disabled={this.props.disabled}
                    customInput={<this.TimeCustomInput></this.TimeCustomInput>}
                />
            );
        }else{
            var dtformat = dateFormat;
            
            if (dateFormat == null) {
                dtformat = "dd-MM-yyyy";
            }

            if(this.props.convertvalue && value !== ''){
                let mm = parseInt(value.substring(dtformat.search("MM"), dtformat.search("MM") + 2)) - 1
                let dd = parseInt(value.substring(dtformat.search("dd"), dtformat.search("dd") + 2))
                let yy = parseInt(value.substring(dtformat.search("yyyy"), dtformat.search("yyyy") + 4))
                xValue = new Date(yy,mm,dd);
            }
            return (
                <DatePicker className="form-control"
                    locale="id"
                    selected={xValue}
                    minDate={minDate}
                    maxDate={maxDate}
                    disabled={this.props.disabled}
                    onChange={(date) => {
                        if(this.props.convertvalue){
                            const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date)
                            const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date)
                            const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date)
                            // const v = `${da}-${mo}-${ye}`
                            let v = dtformat
                            v = v.replace('dd',da)
                            v = v.replace('yyyy',ye)
                            v = v.replace('MM',mo)

                            this.props.onChange(field, v);
                        }else{
                            this.props.onChange(field, date);
                        }
                        
                    }}
                    dateFormat={ dtformat }
                    showYearDropdown
                    customInput={<this.DateCustomInput></this.DateCustomInput>}
                />
            );
        }

        
    }
}

export default (DateInputField);
